import React, { useState, useEffect } from 'react';
import github from '../services/github';

const REPOS = [
  { owner: 'quangnhan', repo: 'human-lab-process-12-videos-release', title: 'Human Lab Processor' },
  { owner: 'quangnhan', repo: 'human-lab-record-12-videos-release', title: 'Human Lab Recorder' },
];

function formatSize(bytes) {
  if (!bytes) return '';
  const mb = bytes / (1024 * 1024);
  return `${mb.toFixed(1)} MB`;
}

function DownloadCard({ title, owner, repo }) {
  const [release, setRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    github
      .getLatestRelease(owner, repo)
      .then((data) => {
        if (!cancelled) setRelease(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [owner, repo]);

  return (
    <div className="download-card">
      <h3>{title}</h3>
      {loading && <p>Đang tải thông tin bản mới nhất...</p>}
      {error && <div className="error-message">{error}</div>}
      {release && (
        <>
          <p className="download-meta">
            Phiên bản {release.tag}
            {release.size ? ` · ${formatSize(release.size)}` : ''}
          </p>
          <a
            className="btn btn-primary btn-block"
            href={release.downloadUrl}
            download
          >
            Download
          </a>
        </>
      )}
    </div>
  );
}

function Downloads() {
  return (
    <div className="content-section">
      <h1>Downloads</h1>
      <div className="download-grid">
        {REPOS.map((r) => (
          <DownloadCard key={r.repo} title={r.title} owner={r.owner} repo={r.repo} />
        ))}
      </div>
    </div>
  );
}

export default Downloads;
